module.exports = __webpack_public_path__ + "static/media/14a-01-HOME_ST-2014-130x95cm-oleo-y-aceite-de-lino-sobre-papel.7bf90e88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/14a/14a-01-HOME_ST-2014-130x95cm-oleo-y-aceite-de-lino-sobre-papel.jpg
// module id = 144
// module chunks = 0